// src/containers/Chat/modals/SearchModal.jsx
import React, { useEffect, useRef, useState } from 'react';
import { searchChat } from '../../../actions/chatActions';

export default function SearchModal({ chatId, onClose }) {
    const [q, setQ] = useState('');
    const [dateFrom, setFrom] = useState('');
    const [dateTo, setTo] = useState('');
    const [starred, setStarred] = useState(false);

    const [items, setItems] = useState([]);
    const [cursor, setCursor] = useState(null);
    const [loading, setLoading] = useState(false);
    const wrapRef = useRef(null);

    const load = async (before = null, replace = true) => {
        setLoading(true);
        try {
            const fn = searchChat(chatId, { q, dateFrom: dateFrom || undefined, dateTo: dateTo || undefined, starred, before, limit: 30 });
            const data = await fn();
            setItems(prev => replace ? (data.items || []) : [...prev, ...(data.items || [])]);
            setCursor(data.nextCursor || null);
        } catch (e) {
            console.warn('[SearchModal] error', e?.message || e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { /* initial no-op */ }, []);

    useEffect(() => {
        const el = wrapRef.current;
        if (!el) return;
        const onScroll = () => {
            if (loading || !cursor) return;
            if (el.scrollTop + el.clientHeight >= el.scrollHeight - 100) {
                console.log('[SearchModal] bottom -> load more');
                load(cursor, false);
            }
        };
        el.addEventListener('scroll', onScroll, { passive: true });
        return () => el.removeEventListener('scroll', onScroll);
    }, [cursor, loading]);

    return (
        <div className="modal" onClick={onClose}>
            <div className="modal__body" style={{ width: 720, maxWidth: '95vw', height: '80vh', display: 'grid', gridTemplateRows: 'auto 1fr' }} onClick={(e) => e.stopPropagation()}>
                <div className="modal__head">
                    <div className="modal__title">Поиск по чату</div>
                    <button onClick={onClose}>✕</button>
                </div>

                <div className="modal__content" style={{ display: 'grid', gridTemplateRows: 'auto 1fr', gap: 8 }}>
                    <form onSubmit={(e) => { e.preventDefault(); console.log('[SearchModal] submit'); load(null, true); }} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr auto auto', gap: 8 }}>
                        <input value={q} onChange={e => setQ(e.target.value)} placeholder="Текст..." />
                        <input type="date" value={dateFrom} onChange={e => setFrom(e.target.value)} />
                        <input type="date" value={dateTo} onChange={e => setTo(e.target.value)} />
                        <label style={{ alignSelf: 'center' }}>
                            <input type="checkbox" checked={starred} onChange={e => setStarred(e.target.checked)} /> избранные
                        </label>
                        <button type="submit">Искать</button>
                    </form>

                    <div ref={wrapRef} style={{ overflow: 'auto', borderTop: '1px solid #263043' }}>
                        {items.map(it => (
                            <div key={`${it.type}-${it._id}`} style={{ padding: '8px 0', borderBottom: '1px dashed #263043' }}>
                                {it.type === 'message' ? (
                                    <>
                                        <div style={{ fontSize: 12, color: '#9ca3af' }}>{new Date(it.createdAt).toLocaleString()}</div>
                                        <div style={{ whiteSpace: 'pre-wrap' }}>{it.text || (it.fileName ? `📎 ${it.fileName}` : '(пусто)')}</div>
                                    </>
                                ) : (
                                    <div>📞 {it.call?.video ? 'Видео' : 'Аудио'} звонок • {it.call?.status}</div>
                                )}
                            </div>
                        ))}
                        {loading && <div style={{ padding: 12, textAlign: 'center', color: '#9ca3af' }}>Загрузка…</div>}
                        {!loading && !items.length && <div style={{ padding: 12, textAlign: 'center', color: '#9ca3af' }}>Ничего не найдено</div>}
                    </div>
                </div>
            </div>
        </div>
    );
}
